module.exports = __webpack_public_path__ + "img/id_id.4987b7cc.svg";